const columns = [
  {
    dataField: 'shipment_id',
    text: 'Shipment ID',
    type: 'entity',
    entityType: 'shipment',
    hideable: false,
    sort: true,
    headerStyle: {
      width: '6%',
    },
    localizationSlug: 'SHIPMENT_ID',
  },
  {
    dataField: 'status',
    text: 'Status',
    type: 'status',
    hideable: true,
    sort: true,
    headerStyle: {
      width: '8%',
    },
    localizationSlug: 'STATUS',
  },
  {
    dataField: 'reference_numbers',
    text: 'Reference Numbers',
    type: 'reference_number',
    hideable: true,
    sort: true,
    headerStyle: {
      width: '17%',
    },
    localizationSlug: 'REFERENCE_NUMBERS',
  },
  {
    dataField: 'origin[0]',
    text: 'Origin',
    type: 'location',
    sort: true,
    hideable: true,
    headerStyle: {
      width: '12%',
    },
    localizationSlug: 'ORIGIN',
  },
  {
    dataField: 'destination[0]',
    text: 'Destination',
    type: 'location',
    hideable: true,
    sort: true,
    headerStyle: {
      width: '12%',
    },
    localizationSlug: 'DESTINATION',
  },
  {
    dataField: 'pickup',
    text: 'Pickup',
    type: 'daterange',
    hideable: true,
    sort: true,
    formatExtraData: {
      type: 'pickup',
    },
    localizationSlug: 'PICKUP',
  },
  {
    dataField: 'deliver',
    text: 'Deliver',
    type: 'daterange',
    hideable: true,
    sort: true,
    formatExtraData: {
      type: 'deliver',
    },
    localizationSlug: 'DELIVER',
  },
  {
    dataField: 'loads',
    text: 'Load',
    type: 'loaddetails',
    sort: true,
    hideable: true,
    localizationSlug: 'LOAD',
  },
  {
    dataField: 'carrier',
    text: 'Carrier',
    type: 'customer',
    sort: true,
    hideable: true,
    localizationSlug: 'CARRIER',
  },
  {
    dataField: 'driver',
    text: 'Driver',
    type: 'customer',
    hideable: true,
    sort: true,
    localizationSlug: 'DRIVER',
  },
  {
    dataField: 'total_receivable_rate',
    text: 'Shipper Cost',
    hideable: true,
    type: 'shipper_cost',
    sort: false,
    localizationSlug: 'SHIPPER_COST',
  },
  {
    dataField: 'reference_numbers',
    text: 'Equipments',
    type: 'equipments',
    hideable: true,
    sort: true,
    headerStyle: {
      width: '10%',
    },
    localizationSlug: 'EQUIPMENTS',
  },
];

export default {
  columns,
};
